<ng-container *ngIf="noticia?.urlVideo && showDivVideo">
  <div class="contenedor-video-youtube" [ngClass]="videoPausado() ? 'noclick' : ''" id="divVideo">
    <ng-container *ngIf="videoPausado()">
      <app-animacion-video #animacion class="animacion-video" (close)="closeAnimation()" [videoCargando]="videoCargando()"></app-animacion-video>
      <app-skeleton-image class="div-over-video" [customClass]="'no-radius image'" [created]="noticia?.fechaCreacion" [size]="980" [src]="noticia?.urlGenerica" [lazy]="false" [aspectRatio]="980 / 555" [alt]="noticia?.tituloVideo"></app-skeleton-image>
    </ng-container>

    <ng-container *ngIf="videoType === 'youtube'">
      <div class="responsive-iframe">
        <div id="player" class="embedPlayerYt"></div>
      </div>
    </ng-container>
    <ng-container *ngIf="videoType === 'dailymotion'">
      <div class="dmWrapper">
        <div class="dmPlayer"></div>
      </div>
    </ng-container>
    <ng-container *ngIf="!esVideoYoutube(noticia?.urlVideo) && !esDailymotion(noticia?.urlVideo)">
      <video #customVideo id="customVideo" class="custom-video" width="100%" height="100%" controls="controls" (pause)="customVideoPause()" (ended)="customVideoPause()" (play)="customVideoPlay()" [src]="noticia?.urlVideo" type="video/mp4"></video>
    </ng-container>
  </div>
</ng-container>
